import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Building2, CheckCircle2 } from 'lucide-react';
const projects = [{
  name: 'Malaga warehouse',
  size: '12,000 sqm',
  detail: '4 weekends, zero business interruption'
}, {
  name: 'Subiaco retail fit out',
  size: '3 stores',
  detail: '6 zones each, same day commissioning'
}, {
  name: 'Joondalup medical practice',
  size: '850 sqm',
  detail: '6 consult rooms, separate clinical zones'
}];
const points = ['Design and install A$5,000 to A$80,000+ range', 'After hours scheduling to protect trading', 'iZone smart zoning for offices and fit outs', 'Full insurance and scope of works documentation'];
export function Commercial() {
  return <section className="bg-white py-20 md:py-28" data-id="element-60" data-mp="ct6dmzxjb894">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61" data-mp="1t4k3a3i3u4ag">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-62" data-mp="1t768vxlfq9q1">
          {/* Content */}
          <div className="lg:col-span-6" data-id="element-63" data-mp="2f24vki9qhvr1">
            <div className="text-xs font-semibold uppercase tracking-widest text-brand mb-4" data-id="element-64" data-mp="2f138tgjcvkth">
              Commercial HVAC
            </div>
            <h2 className="text-2xl md:text-4xl font-bold tracking-tight text-ink leading-tight mb-6" data-id="element-65" data-mp="2k32b0n3d0bou">
              For Perth offices, retail, warehouses and trades.
            </h2>
            <p className="text-lg text-stone-600 leading-relaxed mb-8 max-w-xl" data-id="element-66" data-mp="2t14hvj9rxyk1">
              Commercial buyers have different priorities: fit for purpose
              design, minimal trading interruption, proper documentation. We
              design and supply install HVAC for Perth businesses, sized
              correctly the first time.
            </p>

            <div className="space-y-3 mb-9" data-id="element-67" data-mp="2a3bius29u8rx">
              {points.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.05
            }} className="flex items-center gap-3" data-id="element-68" data-mp="1dlourxl3t721" data-mpi={i}>
                  <CheckCircle2 size={18} className="text-success flex-shrink-0" data-id="element-69" data-mp="2pqhebdnc5fhn" />
                  <span className="text-base text-ink font-medium" data-id="element-70" data-mp="1x08y3rcd155p">{item}</span>
                </motion.div>)}
            </div>

            <a href="/commercial-air-conditioning-installation-in-perth/" className="inline-flex items-center gap-2 h-14 px-8 rounded-xl bg-accent hover:bg-accent-600 text-ink text-base font-bold transition-all hover:scale-[1.02] shadow-lg shadow-accent/20" data-id="element-71" data-mp="2b0tdedj2giug">
              Get a commercial quote
              <ArrowUpRight size={16} strokeWidth={2.5} data-id="element-72" data-mp="3pwumuv896yak" />
            </a>
          </div>

          {/* Recent projects card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-6" data-id="element-73" data-mp="3uwpe4zvxxpw5">
            <div className="bg-brand text-white rounded-2xl p-7 lg:p-9 shadow-xl" data-id="element-74" data-mp="hfq62qjoqx75">
              <div className="flex items-center gap-3 mb-7" data-id="element-75" data-mp="2sn6mebsyeh6">
                <div className="w-10 h-10 rounded-lg bg-accent text-ink flex items-center justify-center" data-id="element-76" data-mp="2q0x495cpowb">
                  <Building2 size={18} data-id="element-77" data-mp="vgj25fpmy0cd" />
                </div>
                <div className="text-xs uppercase tracking-widest text-white/70 font-semibold" data-id="element-78" data-mp="vezg18hasv2o">
                  Recent commercial installs
                </div>
              </div>

              <div className="space-y-5" data-id="element-79" data-mp="38p3g42ne4qsy">
                {projects.map((project, i) => <div key={i} className="pb-5 border-b border-white/15 last:border-0 last:pb-0" data-id="element-80" data-mp="33o7a9jjhaukw" data-mpi={i}>
                    <div className="flex items-baseline justify-between mb-1.5 gap-3" data-id="element-81" data-mp="2tr2pno5a7767">
                      <div className="text-lg font-bold tracking-tight" data-id="element-82" data-mp="2ttfgyrwxitvx">
                        {project.name}
                      </div>
                      <div className="text-xs uppercase tracking-wider text-white/70 font-semibold tabular-nums whitespace-nowrap" data-id="element-83" data-mp="3mfgo250a85ia">
                        {project.size}
                      </div>
                    </div>
                    <div className="text-sm text-white/80" data-id="element-84" data-mp="3cpdwm98t6zm2">
                      {project.detail}
                    </div>
                  </div>)}
              </div>

              <div className="mt-7 pt-7 border-t border-white/15 flex items-center justify-between gap-4" data-id="element-85" data-mp="985f5qhzu1rv">
                <div data-id="element-86" data-mp="hj5rpk4kwknv">
                  <div className="text-3xl font-extrabold tracking-tight tabular-nums" data-id="element-87" data-mp="hjxec5g77820">
                    A$5K to A$80K
                  </div>
                  <div className="text-[11px] uppercase tracking-wider text-white/70 mt-1" data-id="element-88" data-mp="qhzlz3ufsyy9">
                    Typical project range
                  </div>
                </div>
                <a href="tel:+61864043888" className="text-sm font-bold text-accent hover:underline underline-offset-2 whitespace-nowrap" data-id="element-89" data-mp="10gotc2opj109">
                  Talk to our team →
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}